import Stats from 'stats-js/build/stats';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      FpsStats: Stats,
    },
  };
});
